<fw-dialog width="extra-small" [showClose]="true" title="Register New DICOM Peer">
  <fw-dialog-content>
    <form [formGroup]="form">
        <mat-form-field appearance="outline">
          <mat-label>AE Title</mat-label>
          <input test-id="aet" matInput name="aet" formControlName="aet">
          <mat-error *ngIf="form.get('aet').hasError('required')">{{ 'addDicomPeerDialog.aetError' | translate }}</mat-error>
          <mat-error *ngIf="form.get('aet').hasError('maxlength')">{{ 'addDicomPeerDialog.aetTooLong' | translate }}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>IP/Hostname</mat-label>
          <input test-id="host" matInput name="host" formControlName="host">
          <mat-error>{{ 'addDicomPeerDialog.ipHostError' | translate }}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Port</mat-label>
          <input type="number" test-id="port" matInput name="port" formControlName="port">
          <mat-error>{{ 'addDicomPeerDialog.portError' | translate }}</mat-error>
        </mat-form-field>
    </form>
    <div test-id="test-result" *ngIf="ranConnectionTest" class="connection-test-result">
      <p *ngIf="connectionTestPass" class="green">{{ connectionTestMsg }}</p>
      <p *ngIf="!connectionTestPass" class="red">{{ connectionTestMsg }}</p>
    </div>
  </fw-dialog-content>

  <fw-dialog-actions>
    <fw-button
      test-id="test-connection"
      [variant]="showSpinner ? 'progress' : 'outline'"
      [disabled]="!canTestConnection()"
      (click)="testConnection()">
      Test Connection
    </fw-button>
    <fw-button
      test-id="close"
      data-id="device-modal-close"
      variant="outline"
      (click)="closeDialog()">
      Close
    </fw-button>
    <fw-button
      test-id="add"
      data-id="device-modal-add"
      [disabled]="form.invalid"
      (click)="addPeer()">
      Add
    </fw-button>
  </fw-dialog-actions>

</fw-dialog>
